"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Title = _interopRequireDefault(require("../Title"));
var _Link = _interopRequireDefault(require("../Link"));
var _ExpandableContentBlock = _interopRequireDefault(require("./ExpandableContentBlock.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "ExpandableContentBlock__Wrapper",
  componentId: "sc-1d0f9nk-0"
})(["display:inline;#textContent{white-space:break-spaces;}"]);
Wrapper.displayName = 'Wrapper';
var TextWrapper = _styledComponents.default.div.withConfig({
  displayName: "ExpandableContentBlock__TextWrapper",
  componentId: "sc-1d0f9nk-1"
})(["display:", ";"], function (props) {
  return props.show ? 'none' : 'inline';
});
TextWrapper.displayName = 'TextWrapper';
var ExpandedTextWrapper = _styledComponents.default.div.withConfig({
  displayName: "ExpandableContentBlock__ExpandedTextWrapper",
  componentId: "sc-1d0f9nk-2"
})(["display:", ";"], function (props) {
  return props.show ? 'inline' : 'none';
});
ExpandedTextWrapper.displayName = 'ExpandedTextWrapper';
var RenderContainer = function RenderContainer(props) {
  var title = props.title,
    text = props.text,
    sliceLimit = props.sliceLimit,
    titleColor = props.titleColor,
    titleType = props.titleType,
    titleMarginBottom = props.titleMarginBottom,
    textColor = props.textColor,
    textType = props.textType,
    expandCtaText = props.expandCtaText,
    compressCtaText = props.compressCtaText,
    ctaColor = props.ctaColor,
    ctaSize = props.ctaSize,
    ctaUnderlined = props.ctaUnderlined,
    ctaHoverColor = props.ctaHoverColor,
    ctaHoverUnderlined = props.ctaHoverUnderlined,
    accessible = props.accessible;
  var limit = sliceLimit || text.length;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showMoreToggle = _useState2[0],
    setShowMoreToggle = _useState2[1];
  var titleProps = {
    type: titleType,
    color: titleColor,
    marginBottom: titleMarginBottom,
    accessible: accessible
  };
  var textProps = {
    type: textType,
    color: textColor,
    accessible: accessible
  };
  var showMoreClick = function showMoreClick() {
    setShowMoreToggle(!showMoreToggle);
  };
  var ctaLinkProps = {
    callback: showMoreClick,
    // eslint-disable-next-line no-script-url
    href: 'javascript:void(0);',
    target: 'callback',
    size: ctaSize,
    color: ctaColor,
    underlined: ctaUnderlined,
    hoverColor: ctaHoverColor,
    hoverUnderlined: ctaHoverUnderlined,
    accessible: accessible
  };
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, title && /*#__PURE__*/_react.default.createElement(_Title.default, titleProps, title), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({}, textProps, {
    customProperties: {
      id: 'textContent'
    },
    display: "inline"
  }), text.substr(0, limit)), limit < text.length && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TextWrapper, {
    show: showMoreToggle
  }, /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({}, textProps, {
    display: "inline"
  }), "..."), /*#__PURE__*/_react.default.createElement(_Link.default, ctaLinkProps, expandCtaText)), /*#__PURE__*/_react.default.createElement(ExpandedTextWrapper, {
    show: showMoreToggle
  }, /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({}, textProps, {
    display: "inline",
    customProperties: {
      id: 'textContent'
    }
  }), text.substr(limit)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Link.default, ctaLinkProps, compressCtaText))))));
};
var ExpandableContentBlock = function ExpandableContentBlock(props) {
  var theme = props.theme;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  return themeContext ? /*#__PURE__*/_react.default.createElement(RenderContainer, props) : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(RenderContainer, props));
};
RenderContainer.propTypes = _ExpandableContentBlock.default.PropTypes;
ExpandableContentBlock.propTypes = _ExpandableContentBlock.default.PropTypes;
ExpandableContentBlock.defaultProps = _ExpandableContentBlock.default.DefaultProps;
ExpandableContentBlock.displayName = 'ExpandableContentBlock';
var _default = ExpandableContentBlock;
exports.default = _default;